module.exports = __webpack_public_path__ + "static/media/partnew-text.5fd6de06.png";